export type EnvConfig = {
  API_BASE_URL: string
  PROBLEMS_LOGGING_IN: string
  ONETRUST_DOMAIN_SCRIPT: string
  ONETRUST_FUNCTIONAL_GROUPS: string
}

export const defaultEnvConfig: EnvConfig = {
  API_BASE_URL: '',
  PROBLEMS_LOGGING_IN: '',
  ONETRUST_DOMAIN_SCRIPT: '',
  ONETRUST_FUNCTIONAL_GROUPS: '',
}
